export class Container {
    Id: string | null;
    Tenant: number | null;
    CreateDate: Date | null;
    CreatedByUserId: string | null;
    UpdateDate: Date | null;
    UpdatedByUserId: string | null;
    SearchFields: string | null;
    ContainerNumber: string | null;
    ShipmentPackagesId: string | null;
    MainCarriageCarrierId: string | null;
    CarrierName: string | null;
    MainCarriageCarrierNumber: string | null;
    Master: string | null;
    MainCarriageVesselId: string | null;
    VesselName: string | null;
    MainCarriageETA: Date | null;
    MainCarriageETD: Date | null;
    MainCarriageATA: Date | null;
    MainCarriageATD: Date | null;
    DischargeDate: Date | null;
    ShipmentId: string | null;
    EmptyPickupLocation: string | null;
    EstimatedEmptyPickupDate: Date | null;
    ActualEmptyPickupDate: Date | null;
    EstimatedGateInDate: Date | null;
    ActualGateInDate: Date | null;
    DepartureLocation: string | null;
    DestinationLocation: string | null;
    CurrentStatus: string | null;
    CurrentStatusDate: Date | null;
    CurrentLocation: string | null;
    HasContainerException: boolean | null;
}